export default "__VITE_ASSET__wPc4_KdT__"